module.exports = __webpack_public_path__ + "tg.svg?bf9d20b8945bd53245c9ea1e1eed2a4f";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/tg.svg
// module id = 1642
// module chunks = 0